import React from "react";
import SEO from "../components/SEO";

const HOODIE = [
  { s: "S", chest_cm: 110, length_cm: 66, chest_in: 43, length_in: 26 },
  { s: "M", chest_cm: 114, length_cm: 68, chest_in: 45, length_in: 27 },
  { s: "L", chest_cm: 118, length_cm: 70, chest_in: 46, length_in: 28 },
  { s: "XL", chest_cm: 122, length_cm: 72, chest_in: 48, length_in: 28 },
  { s: "XXL", chest_cm: 126, length_cm: 74, chest_in: 50, length_in: 29 },
];
const TEE = [
  { s: "S", chest_cm: 104, length_cm: 68, chest_in: 41, length_in: 27 },
  { s: "M", chest_cm: 108, length_cm: 70, chest_in: 43, length_in: 28 },
  { s: "L", chest_cm: 112, length_cm: 72, chest_in: 44, length_in: 28 },
  { s: "XL", chest_cm: 116, length_cm: 74, chest_in: 46, length_in: 29 },
  { s: "XXL", chest_cm: 120, length_cm: 76, chest_in: 47, length_in: 30 },
];
const Table = ({ rows, title }) => (
  <div className="mb-12">
    <h2 className="font-serif text-2xl mb-4">{title}</h2>
    <div className="border border-white/10 overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-white/5">
          <tr><th className="p-3 text-left">Size</th><th className="p-3 text-left">Chest (cm)</th><th className="p-3 text-left">Length (cm)</th><th className="p-3 text-left">Chest (in)</th><th className="p-3 text-left">Length (in)</th></tr>
        </thead>
        <tbody>
          {rows.map((r) => <tr key={r.s} className="border-t border-white/10"><td className="p-3 font-mono-cap">{r.s}</td><td className="p-3">{r.chest_cm}</td><td className="p-3">{r.length_cm}</td><td className="p-3">{r.chest_in}</td><td className="p-3">{r.length_in}</td></tr>)}
        </tbody>
      </table>
    </div>
  </div>
);

const SizeGuide = () => (
  <>
    <SEO title="Size Guide" />
    <section className="max-w-3xl mx-auto px-6 py-16">
      <p className="font-mono-cap text-[10px] text-white/40">Sizing</p>
      <h1 className="font-serif text-5xl mt-2">Size Guide.</h1>
      <p className="text-white/60 mt-3">All pieces are designed oversized. Measure a hoodie/tee you already love and compare to the chart below.</p>
      <div className="mt-10">
        <Table rows={HOODIE} title="Hoodies" />
        <Table rows={TEE} title="Tees" />
      </div>
    </section>
  </>
);
export default SizeGuide;
